<!--
 * @Author: your name
 * @Date: 2020-04-30 15:37:21
 * @LastEditTime: 2020-04-30 15:44:46
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlonmarinesite\src\components\contentcoms\newscontentcoms\new16.vue
 -->
 <template>
  <div class="body-width divcss5">
    <div class="div-row div-bottom news-Medium-24">
      尹勇教授荣获英国皇家航海学会最高学术论文奖“迈克尔•里奇奖章”(Michael Richey Medal)
      <!-- <span class="news-Regular-14">作者：何舒 来源：科技处 添加时间：2019-05-09 09:13:27</span> -->
    </div>
    <div class="div-text-left news-Regular-14b6">
      <span>2020-04-30</span><span class="div-padding-left">大连海大智龙科技有限公司</span>
    </div>
    <div class="div-line  divcss5"></div>
    <div class="div-row div-bottom10">
      <p class="indentation">
        4月14日，英国皇家航海学会理事长、现任国际航行学会联合会(IAIN)主席John
        Pottle先生发来贺信。大连海事大学航海学院吕红光副教授和大连海大智龙科技有限公司尹勇教授在船舶自主避碰领域的研究长文“COLREGS-Constrained Real-time Path Planning for
        Autonomous Ships Using Modified Artificial Potential Fields”，获得了英国皇家航海学会的最高学术论文奖“迈克尔·里奇奖章”(Michael Richey
        Medal)。
      </p>
      <p class="indentation">
        该论文提出一种受《国际海上避碰规则》约束的、基于改进人工势场法的多船实时自主避碰决策算法。该方法可考虑我船的运动特性及他船的不协调避碰行动，具有方法简单、计算速度快、鲁棒性强、求解确定性等优点，便于在实船智能避碰系统中应用。论文发表后，受到国内外同行的高度关注，入选2019年ESI
        1%高被引论文以及该期刊最高下载量论文，近日还将被剑桥大学出版社网站转载展览6个月并通过英国皇家航海学会的社交媒体进行宣传。
      </p>
      <p class="indentation">
        据悉，该奖章以英国皇家航海学会创立者的名字命名，首次颁发于1950年，每年根据相关领域的学术和技术专家，以及皇家航海学会整个技术委员会的投票，授予上一年在剑桥大学出版社SCI期刊Journal of
        Navigation上发表的最杰出论文（仅一篇）的作者，是学术卓越，智识严谨，导航研究的实际应用和导航科学领域最佳努力的象征(a symbol of academic excellence, intellectual
        rigour, the practical application of navigation research, and the best endeavour in the field of navigation
        science)。多年来，由英国女王伊丽莎白二世的丈夫爱丁堡公爵菲利普亲王(HRH Prince Philip)亲自授奖。今年由于疫情，原定于6月30日在英国皇家地理学会总部举行的颁奖典礼，将延期或以线上方式举办。
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {

      };
    },
    methods: {

    },
  };

</script>

<style scoped>
  .fl {
    float: right;
    margin-right: 20px;
  }

  .fy {
    text-align: center;
    margin-top: 30px;
  }

  .title {
    height: 100%;
  }

  .div-width {
    width: 75%;
  }



  .div-line {
    background: #E6E6E6;
    height: 1px;
    width: 100%;

  }

  .div-bottom10 {
    padding-top: 10px;
  }

  .div-bottom30 {
    padding-top: 30px;
    padding-bottom: 30px;
  }

  .div-top30 {
    padding-top: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/components/contentcoms/news2020/news16.vue